module.exports = __webpack_public_path__ + "static/wave-cd9594c948f914d7a4ebb0babcf7a090.png";